<template>
    <div class="outlined rounded-lg pt-4 pr-4 pl-4" style="border-color: #6B7280">
        <h2 class="h5 mb-4" @click="hideUpload = !hideUpload"><i class="fa" v-bind:class="{'fa-angle-right' : !hideUpload, 'fa-angle-down' : hideUpload}"></i>   Upload documents</h2>
		<div v-if="hideUpload" class="pb-4">
			<label>Files for carrier e.g. customs clearance</label>
			<file-uploader :files="files" @deleted="$emit('deleted', $event)" @uploaded="$emit('uploaded', $event)"></file-uploader>
		</div>
    </div>
</template>

<script>
	import FileUploader from '../../../utils/FileUploader';

    export default {
        name: 'file-upload',
		inject: ['$validator'],
		components: { FileUploader },
		props: ['files'],
		
		data() {
			return {
				uploading: false,
				file: null,
				hideUpload: false,
			}
		}
    }
</script>